import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  updateCircularApi,
} from "../../../../services/DocumentService";

const EditCircularSheet = ({ data, handleAfterUpdate }) => {
  const [dataInput, setDataInput] = useState({
    title: "",
    schedule: "",
    schedule_at: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (data) {
      setDataInput({
        id: data?.measurement_sheet?.id || "",
        title: data.title || "",
        schedule: data.schedule || "",
        schedule_at: data.circular_schedule?.schedule_at || "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataInput((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleTimeChange = (value) => {
    setDataInput((prev) => ({ ...prev, schedule_at_time: value }));
    setErrors((prev) => ({ ...prev, schedule_at_time: "" }));
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;

    try {
      setIsSubmitLoading(true);
      const payload = { ...dataInput };
      const response = await updateCircularApi(id, payload);
      handleAfterUpdate(response.data.results);
      toast.success(response.data.message);
      closeModal();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred while submitting"
      );
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const validateInputs = () => {
    const newErrors = {};
    if (!dataInput.title) newErrors.title = "Title is required.";
    if (!dataInput.schedule) newErrors.schedule = "Schedule is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <button
        className="btn btn-outline-primary btn-sm ms-1"
        onClick={openModal}
      >
        <i className="fa-solid fa-pen-to-square"></i> Edit
      </button>
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Circular</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            {/* Title */}
            <div className="form-group mb-3">
              <label className="form-label">
                Title<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Title"
                name="title"
                value={dataInput.title}
                onChange={handleChange}
              />
              {errors.title && (
                <div className="text-danger">{errors.title}</div>
              )}
            </div>

            {/* Schedule */}
            <div className="form-group mb-3">
              <label className="form-label">
                Schedule<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                placeholder="Enter Schedule"
                name="schedule"
                value={dataInput.schedule}
                onChange={handleChange}
              />
              {errors.schedule && (
                <div className="text-danger">{errors.schedule}</div>
              )}
            </div>

            {/* Schedule Date */}
            <div className="form-group mb-3">
              <label className="form-label">
                Schedule At<span className="text-danger">*</span>
              </label>
              <input
                type="datetime-local"
                className="form-control"
                name="schedule_at"
                value={dataInput.schedule_at}
                onChange={handleChange}
              />
              {/* {errors.schedule_date && (
                <div className="text-danger">{errors.schedule_date}</div>
              )} */}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitLoading}
          >
            {isSubmitLoading ? "Updating..." : "Update  "}
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditCircularSheet;

//   <div className="container-fluid">
//   <div className="row px-sm-2 px-0">
//     <div className="col-xl-12">
//       <div className="card px-sm-3 px-1">
//         <div className="card-body">
//           <h3 className="text-center mb-3">Edit Circular Form</h3>
//           <form>
//             <div className="row mb-2">
//               <div className="col-md-6">
//                 <div className="form-group mb-3">
//                   <label className="form-label">
//                     Title<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     className="form-control mb-3"
//                     placeholder="Enter Title"
//                     name="title"
//                     value={dataInput.title}
//                     onChange={handleChange}
//                   />
//                   {errors.title && (
//                     <div className="text-danger">{errors.title}</div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <StaticSelectInput
//                   setParentInputValue={handleSelectChange}
//                   optionsList={sheetOptions?.map((item) => ({
//                     value: item.value,
//                     label: item.label,
//                   }))}
//                   name="measurement_sheet_id"
//                   id="measurement_sheet_id"
//                   isClearable
//                   placeholder="Select MeasurementSheet"
//                   label="MeasurementSheet"
//                   isRequired={true}
//                   defaultValue={{
//                     value: data.measurement_sheet.id,
//                     label: data.measurement_sheet.title,
//                   }}
//                 />
//                 {errors.measurement_sheet_id && (
//                   <div className="text-danger">
//                     {errors.measurement_sheet_id}
//                   </div>
//                 )}
//               </div>
//               <div className="col-md-6">
//                 <div className="form-group mb-3">
//                   <label className="form-label">
//                     Schedule<span className="text-danger">*</span>
//                   </label>
//                   <input
//                     className="form-control mb-3"
//                     placeholder="Enter Schedule"
//                     name="schedule"
//                     value={dataInput.schedule}
//                     onChange={handleChange}
//                   />
//                   {errors.schedule && (
//                     <div className="text-danger">{errors.schedule}</div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="form-group mb-3">
//                   <StaticSelectInput
//                   setParentInputValue={handleSelectChange}
//                   optionsList={scheduleTypeOptionList}
//                   name="schedule_type"
//                   id="schedule_type"
//                   isClearable
//                   placeholder="Enter Schedule Type"
//                   label="Schedule Type"
//                   isRequired={true}
//                   defaultValue={{
//                     label: getLabelByValue(data.circular_schedule.schedule_type, scheduleTypeOptionList),
//                     value: data.circular_schedule.schedule_type,
//                   }}
//                 />
//                   {errors.schedule_type && (
//                     <div className="text-danger">
//                       {errors.schedule_type}
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <label className="form-label">
//                   Schedule Time<span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="time"
//                   className="form-control mb-3"
//                   placeholder="Enter Schedule Time"
//                   name="schedule_time"
//                   value={dataInput.schedule_time}
//                   onChange={handleChange}
//                 />
//                 {errors.schedule_time && (
//                   <div className="text-danger">{errors.schedule_time}</div>
//                 )}
//               </div>
//               {dataInput.schedule_type === "once" && (
//               <div className="col-md-6">
//                 <label className="form-label">
//                   Schedule Date<span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="date"
//                   className="form-control mb-3"
//                   placeholder="Enter Schedule Date"
//                   name="schedule_date"
//                   value={dataInput.schedule_date}
//                   onChange={handleChange}
//                 />
//               </div>
//               ) }
//               {dataInput.schedule_type === "repeat" && (
//               <>
//               <div className="col-md-6">
//                 <label className="form-label">
//                   Day of Month<span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="number"
//                   className="form-control mb-3"
//                   placeholder="Enter Day of Month"
//                   name="day_of_month"
//                   value={dataInput.day_of_month}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label className="form-label">
//                   Month of Year<span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="number"
//                   className="form-control mb-3"
//                   placeholder="Enter Month of Year"
//                   name="month_of_year"
//                   value={dataInput.month_of_year}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label className="form-label">
//                   Day of Week<span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="number"
//                   className="form-control mb-3"
//                   placeholder="Enter Day of Week"
//                   name="day_of_week"
//                   value={dataInput.day_of_week}
//                   onChange={handleChange}
//                 />
//               </div>
//               </>
//               )}
//             </div>

//             <div className="d-flex align-items-center justify-content-start">
//               <button
//                 type="button"
//                 className="btn btn-primary me-3"
//                 onClick={handleSubmit}
//                 disabled={isSubmitLoading}
//               >
//                 {isSubmitLoading ? "Updating..." : "Update"}
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 onClick={() => navigate(`/circular/${id}`)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   </div>
// </div>
